<template>
  <oxd-dialog class="orangehrm-dialog-modal" @update:show="$emit('close')">
    <div class="orangehrm-modal-header">
      <oxd-text type="card-title">{{ attachment.name }}</oxd-text>
    </div>
    <oxd-divider />
    <div class="orangehrm-attachment-preview">
      <img v-if="isImage" :src="attachment.url" :alt="attachment.name" />
      <iframe v-else-if="isPdf" :src="attachment.url" :title="attachment.name" />
      <oxd-text v-else type="subtitle-2">
        Preview is not available for this file type. Use Download to open it.
      </oxd-text>
    </div>
    <oxd-divider />
    <oxd-form-actions>
      <a
        class="orangehrm-attachment-download"
        :href="attachment.url"
        :download="attachment.name"
        target="_blank"
        rel="noopener"
      >
        Download
      </a>
      <oxd-button
        type="button"
        display-type="ghost"
        label="Close"
        @click="$emit('close')"
      />
    </oxd-form-actions>
  </oxd-dialog>
</template>

<script>
import {computed} from 'vue';
import {OxdDialog} from '@ohrm/oxd';

export default {
  name: 'LeaveAttachmentModal',
  components: {'oxd-dialog': OxdDialog},
  props: {
    attachment: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  setup(props) {
    const extension = computed(() => String(props.attachment.name || '').split('.').pop().toLowerCase());
    return {
      isImage: computed(() => ['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(extension.value)),
      isPdf: computed(() => extension.value === 'pdf'),
    };
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-attachment-preview {
  display: flex;
  min-height: 12rem;
  max-height: 60vh;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 1rem;
  background: $oxd-background-pastel-white-color;
}

.orangehrm-attachment-preview img {
  max-width: 100%;
  max-height: 55vh;
  object-fit: contain;
}

.orangehrm-attachment-preview iframe {
  width: 100%;
  min-height: 55vh;
  border: 0;
}

.orangehrm-attachment-download {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  border-radius: 0.5rem;
  padding: 0 1rem;
  color: #fff;
  background: $oxd-primary-one-color;
  font-weight: 700;
  text-decoration: none;
}
</style>
